/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const resourceEndpointCurlPlaceholder = 'https://<YOUR_ENDPOINT_HERE>/';

export const commonDemosMessages = defineMessages({
    copy: { id: 'languageStudio.demoPage.copy', defaultMessage: 'Copy' },
    onText: { id: 'languageStudio.demoPage.onText', defaultMessage: 'On' },
    cloud: { id: 'languageStudio.demoPage.cloud', defaultMessage: 'Cloud' },
    offText: { id: 'languageStudio.demoPage.offText', defaultMessage: 'Off' },
    options: { id: 'languageStudio.demoPage.options', defaultMessage: 'Options' },
    platforms: { id: 'languageStudio.demoPage.platforms', defaultMessage: 'Platforms' },
    originalText: { id: 'languageStudio.demoPage.originalText', defaultMessage: 'Original text' },
    confidenceLabel: { id: 'languageStudio.demoPage.confidenceLabel', defaultMessage: 'Confidence:' },
    dockerContainer: { id: 'languageStudio.demoPage.dockerContainer', defaultMessage: 'Docker container' },
    textCurlPlaceholder: { id: 'languageStudio.demoPage.textCurlPlaceholder', defaultMessage: 'text here' },
    noEntitiesFound: { id: 'languageStudio.demoPage.noEntitiesFound', defaultMessage: 'No entities found' },
    languageDetected: { id: 'languageStudio.demoPage.languageDetected', defaultMessage: 'Language detected' },
    inputErrorTitle: { id: 'languageStudio.demoPage.inputErrorTitle', defaultMessage: 'Empty input is not valid' },
    selectTranslator: { id: 'languageStudio.demoPage.selectTranslator', defaultMessage: 'Select a Translator resource' },
    categorySortOption: { id: 'languageStudio.demoPage.categorySortOption', defaultMessage: 'Category (Alphabetical)' },
    languageErrorTitle: { id: 'languageStudio.demoPage.languageErrorTitle', defaultMessage: 'Empty language is not valid' },
    selectLanguageStudio: { id: 'languageStudio.demoPage.selectLanguageStudio', defaultMessage: 'Select a Language resource' },
    azureResourceErrorTitle: { id: 'languageStudio.demoPage.azureResourceErrorTitle', defaultMessage: 'Invalid Azure resource' },
    languageCurlPlaceholder: { id: 'languageStudio.demoPage.languageCurlPlaceholder', defaultMessage: 'your language code here' },
    languageErrorMessage: { id: 'languageStudio.demoPage.languageErrorMessage', defaultMessage: 'Please select language first.' },
    confidenceAscSortOption: { id: 'languageStudio.demoPage.confidenceAscSortOption', defaultMessage: 'Confidence (low to high)' },
    countryHintCurlPlaceholder: { id: 'languageStudio.demoPage.countryHintCurlPlaceholder', defaultMessage: 'country hint  here' },
    inputErrorMessage: { id: 'languageStudio.demoPage.inputErrorMessage', defaultMessage: 'Please enter text and question first.' },
    confidenceDescSortOption: { id: 'languageStudio.demoPage.confidenceDescSortOption', defaultMessage: 'Confidence (high to low)' },
    subscriptionKeyCurlPlaceholder: { id: 'languageStudio.demoPage.subscriptionKeyCurlPlaceholder', defaultMessage: 'subscription key' },
    conversationItemCurlPlaceholder: {
        id: 'languageStudio.demoPage.conversationItemCurlPlaceholder',
        defaultMessage: 'your conversation items'
    },
    signedOutEmptyState: {
        id: 'languageStudio.demoPage.signedOutEmptyState',
        defaultMessage: `Your results will appear here once you press Run.`
    },
    resourceRegionError: {
        id: 'languageStudio.demoPage.resourceRegionError',
        defaultMessage: 'Your resource’s region {region} is not supported. Select a new resource'
    },
    seeRegionsLink: {
        id: 'languageStudio.demoPage.seeRegionsLink',
        defaultMessage: 'see the list of available regions'
    },
    resourceRegionDetailedError: {
        id: 'languageStudio.demoPage.resourceRegionDetailedError',
        defaultMessage:
            'Your selected Azure resource is in the {region} region, is not supported in capability. Select a resource in a supported region or create a new resource in settings or'
    },
    resourceRegionDetailedErrorPart2: {
        id: 'languageStudio.demoPage.resourceRegionDetailedErrorPart2',
        defaultMessage: 'for this capability.'
    },
    resourceKindError: {
        id: 'languageStudio.demoPage.resourceKindError',
        defaultMessage:
            'Your selected Azure resource is not a Language resource which is required to use this capability. You can change your resource to a Language resource or create a new one in settings'
    },
    translatorResourceKindError: {
        id: 'languageStudio.demoPage.translatorResourceKindError',
        defaultMessage:
            'Your selected Azure resource is not a Translator resource which is required to use this capability. You can change your resource to a Translator resource or create a new one in settings'
    },
    translatorResourceTierError: {
        id: 'languageStudio.demoPage.translatorResourceTierError',
        defaultMessage:
            'Your selected Translator resource is in invalid tier. Select a valid Translator resource to continue or create a new one in settings'
    },
    selectPaidResourceDetailedError: {
        id: 'languageStudio.demoPage.selectPaidResourceDetailedError',
        defaultMessage:
            'This capability is only available in paid Azure resource tiers and your selected resource is in the free tier. Select a paid Azure resource to continue or create a new one in settings'
    },
    selectResourceErrorMessage: {
        id: 'languageStudio.demoPage.selectResourceErrorMessage',
        defaultMessage: 'You have not selected an Azure resource. You can select Language resource or create a new one in settings.'
    },
    selectTranslatorResourceErrorMessage: {
        id: 'languageStudio.demoPage.selectTranslatorResourceErrorMessage',
        defaultMessage: 'You have not selected an Azure resource. You can select Translator resource or create a new one in settings.'
    },
    subscriptionRegionCurlPlaceholder: {
        id: 'languageStudio.demoPage.subscriptionRegionCurlPlaceholder',
        defaultMessage: 'YOUR_SUBSCRIPTION_REGION'
    },
    appearanceAscSortOption: {
        id: 'languageStudio.demoPage.appearanceAscSortOption',
        defaultMessage: 'Order of appearance (first to last)'
    },
    appearanceDescSortOption: {
        id: 'languageStudio.demoPage.appearanceDescSortOption',
        defaultMessage: 'Order of appearance (last to first)'
    },
    azureResourceInvalidRegionAndSkuErrorMessage: {
        id: 'languageStudio.demoPage.azureResourceInvalidRegionAndSkuErrorMessage',
        defaultMessage: "The selected azure resource isn't in a supported region or has invalid sku tier."
    },
    invalidAzureResourceErrorMessage: {
        id: 'languageStudio.demoPage.invalidAzureResourceErrorMessage',
        defaultMessage: "Invalid Azure resource type or the selected one isn't in a supported region or has invalid sku tier."
    },
    noAzureResourceErrorMessage: {
        id: 'languageStudio.demoPage.noAzureResourceErrorMessage',
        defaultMessage: 'You need to have a valid Azure subscripton and Language resource to use the service.'
    }
});
